const __WEBPACK_NAMESPACE_OBJECT__ = require("next/dist/server/async-storage/cache-scope.external.js");